import _profilePicDropdown from "./ProfilePicDropdownData.json";

const TIMEOUT = 100;

export default {
  getProfilePicDropdown: (getFrom, timeout) =>
    setTimeout(() => getFrom(_profilePicDropdown), timeout || TIMEOUT),
};
